import BestOfferCard from "./BestOfferCard";

export default BestOfferCard;